<template>


    <div class="layout__container">
        <div class="layout__width-90 layout__padding-clear">
            <div class="layout__padding-20-0">
                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">My Print Preferences</h2>
                </div>


                <el-button class="button__base layout__width-200px button-red layout__position-right"
                           v-on:click="newPreference()">
                    Add a new preference
                </el-button>


                <div class="">
                    <div class="layout__width-100 layout__position-left">
                        <el-table :data="preferences"
                                  width="100"
                                  class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
                                  v-loading="loading">
                            <el-table-column prop="cat" label="Category" sortable>
                            </el-table-column>
                            <el-table-column prop="subCat" label="Subcategory" sortable>
                            </el-table-column>
                            <el-table-column prop="size" label="Size" sortable>
                            </el-table-column>
                            <el-table-column prop="orientation" label="Orientation" sortable>
                            </el-table-column>
                            <el-table-column prop="pageCount" label="Page Count" sortable>
                            </el-table-column>
                            <el-table-column prop="foldStyle" label="Fold Style" sortable>
                            </el-table-column>
                            <el-table-column prop="creaseStyle" label="Crease Style" sortable>
                            </el-table-column>
                            <el-table-column prop="stockType" label="Stock Type" sortable>
                            </el-table-column>
                            <el-table-column prop="stockWeight" label="Stock Weight" sortable>
                            </el-table-column>
                            <el-table-column prop="lamination" label="Lamination" sortable>
                            </el-table-column>
                            <el-table-column prop="quant" label="Quantity" sortable>
                            </el-table-column>
                            <el-table-column props="cost" label="Cost" sortable>
                            </el-table-column>
                            <el-table-column props="id" label="Actions" sortable>

                                <template slot-scope="props">
                                    <img class="text__align-center layout__width-30px layout__margin-0-5"
                                         v-on:click="editPreferences(props.row)"
                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/edit.png">
                                    <img class="text__align-center layout__width-30px"
                                         v-on:click="deletePreference(props.row)"
                                         src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/bin.png">
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../../router';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {Loading} from 'element-ui';

    export default {
        name: "emailOrders",
        mixins: [axios, dataFormatter],
        components: {},
        data() {
            return {
                preferences: [],
                loading: false,
                category: '',
                printSpec: {
                    subCategory: '',
                    finishedSizeFilter: '',
                    finishedOrientationFilter: '',
                    foldTypeFilter: '',
                    creasingFilter: '',
                    pageCountFilter: '',
                    stockTypeFilter: '',
                    stockWeightFilter: '',
                    laminationFilter: '',
                    quantityFilter: ''
                }
            }
        },
        created() {
            this.updatePreferences();
        },
        methods: {
            updatePreferences() {
                let customerRef = JSON.parse(this.returnCookie('_customer')).ref

                console.log(customerRef)

                this.getUserPreferences(customerRef)

                let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/CatalogueBookmarks/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&customerRef=` + customerRef
                console.log(skuFinder)

                Axios.get(skuFinder, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)

                        const savedPrefs = response.data.result

                        for (let i = 0; i < savedPrefs.length; i++) {

                            let current = savedPrefs[i];

                            let getPrintDetails = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&priceCode=` + current.priceCode + '&quantity=' + current.quantity
                            console.log(getPrintDetails)
                            Axios.get(getPrintDetails, this.returnHeaderUsingToken())
                                .then(rifat => {
                                    console.log('getting the print spec for each saved price code')
                                    console.log(rifat)

                                    let pref = rifat.data.result.catalogueItems[0]

                                    let newPref = {
                                        'id' : current.id,
                                        'cat': pref.category1,
                                        'subCat': pref.category2,
                                        'size': pref.finishedSize,
                                        'orientation': pref.finishedOrientation,
                                        'foldStyle': pref.foldType,
                                        'creaseStyle': pref.creasing,
                                        'pageCount': pref.pageCount,
                                        'stockType': pref.stockType,
                                        'stockWeight': pref.stockWeight,
                                        'lamination': pref.lamination,
                                        'quant': rifat.data.result.printJobSpec.quantity,
                                        'cost': this.returnFormattedCurrency(rifat.data.result.pricingResult.billNetTotalBeforeDiscount)

                                    }
                                    this.preferences.push(newPref)
                                })
                        }
                    })
            },
            newPreference() {
                console.log('going to the preferences page')
                console.log(this.printSpec)
                console.log(this.category)

                this.$router.push({
                    name: '/account/settings/preferences',
                    params: {
                        printSpec: this.printSpec,
                        category: this.category
                    }

                })
            },
            editPreferences(row) {

                console.log('***** printing the clicked row')

                console.log(row)

                this.category = row.cat;
                this.printSpec.subCategory = row.subCat;
                this.printSpec.finishedSizeFilter = row.size;
                this.printSpec.finishedOrientationFilter = row.orientation;
                this.printSpec.foldTypeFilter = row.foldStyle;
                this.printSpec.creasingFilter = row.creaseStyle;
                this.printSpec.pageCountFilter = row.pageCount;
                this.printSpec.stockTypeFilter = row.stockType;
                this.printSpec.stockWeightFilter = row.stockWeight;
                this.printSpec.laminationFilter = row.lamination;
                this.printSpec.quantityFilter = row.quant.toString();


                // todo missing the

                this.newPreference()


            },
            deletePreference(preference) {

                let loadingInstance = Loading.service({
                    fullscreen: true
                });


                let deletePreference = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/DeleteCatalogueBookmark/?customerRef=` + JSON.parse(this.returnCookie('_customer')).ref + '&favouriteId=' + preference.id
                console.log(deletePreference)
                Axios.delete(deletePreference, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log('result from delete')
                        console.log(response)

                        this.preferences = [];
                        this.updatePreferences()

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                    })
                    .catch(error => {
                        console.log(error)
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    })
            }
        }
    };
</script>